import { IProductTrackingData } from '../../../Catalog/Product/IProductTrackingData.csharp';
import { ProductViewModel } from '../../../Catalog/Product/ViewModels/ProductViewModel.csharp';
import { SearchResultProductViewModel } from '../../../Filtering/Api/SearchResultProductViewModel.csharp';
import { ProductCardViewModel } from '../../../Partials/ProductCard/ProductCardViewModel.csharp';
import { CartItemViewModel } from '../../../Purchase/Cart/Item/ViewModels/CartItemViewModel.csharp';
import { GoogleTagManagerList } from '../GoogleTagManagerList';
import { GTMStockLevel } from '../GTMStockLevel';
import { GA4ItemData } from './GoogleAnalytics4Interfaces';

export class GoogleAnalytics4Mapper {
    private readonly currency = 'NOK';

    public mapProductToItemData = (product: ProductViewModel, originName: string, promotionId?: string, promotionName?: string): GA4ItemData => {
        return {
            item_id: product.code,
            item_name: product.nameInfo.fullName,
            item_brand: product.nameInfo.mainName,
            price: product.price.price,
            item_category: product.subcategory,
            currency: this.currency,
            discount: product.price.originalPrice - product.price.price,
            item_list_name: originName,
            promotion_id: promotionId,
            promotion_name: promotionName,
            stock_level: GTMStockLevel.Get(product.availability)
        };
    };

    public mapProductCardToItemData = (product: ProductCardViewModel): GA4ItemData => {
        return {
            item_id: product.code,
            item_name: product.nameInfo.fullName,
            item_brand: product.nameInfo.mainName,
            price: product.price.price,
            item_category: product.subcategory,
            currency: this.currency,
            discount: product.price.originalPrice - product.price.price,
            item_list_name: product.originName,
            promotion_id: product.promotionId,
            promotion_name: product.promotionName,
            stock_level: GTMStockLevel.Get(product.availability)
        };
    };

    public mapSearchItemToItemData = (product: SearchResultProductViewModel): GA4ItemData => {
        return {
            item_id: product.code,
            item_name: product.nameInfo.fullName,
            item_brand: product.nameInfo.mainName,
            price: product.discountedPrice,
            item_category: product.subcategory,
            currency: this.currency,
            discount: product.placedPrice - product.discountedPrice,
            item_list_name: GoogleTagManagerList.searchResults
        };
    };

    public mapCartItemViewModelToItemData = (product: CartItemViewModel, quantity?: number): GA4ItemData => {
        return {
            item_id: product.code,
            item_name: product.nameInfo.fullName,
            item_brand: product.nameInfo.mainName,
            price: this.getPriceForSingleProduct(product.discountedPrice, product.quantityOrdered),
            item_category: product.subcategory,
            currency: this.currency,
            quantity: quantity || product.quantityOrdered,
            item_list_name: product.originName,
            promotion_id: product.promotionId,
            promotion_name: product.promotionName
        };
    };

    public mapCartItemViewModelToItemDataExtended = (product: CartItemViewModel, index: number, couponCode: string): GA4ItemData => {
        return {
            item_id: product.code,
            item_name: product.nameInfo.fullName,
            item_brand: product.nameInfo.mainName,
            item_category: product.subcategory,
            item_list_name: product.originName,
            coupon: couponCode,
            discount: product.discountValue,
            price: this.getPriceForSingleProduct(product.discountedPrice, product.quantityOrdered),
            quantity: product.quantityOrdered,
            index,
            promotion_id: product.promotionId,
            promotion_name: product.promotionName
        };
    };

    public mapProductTrackingDataToItemData = (
        product: IProductTrackingData,
        quantity?: number,
        originName?: string,
        promotionId?: string,
        promotionName?: string
    ): GA4ItemData => {
        return {
            item_id: product.code,
            item_name: product.nameInfo.fullName,
            item_brand: product.nameInfo.mainName,
            price: product.placedPrice,
            item_category: product.subcategory,
            currency: this.currency,
            quantity: quantity,
            item_list_name: originName,
            promotion_id: promotionId,
            promotion_name: promotionName
        };
    };

    private getPriceForSingleProduct = (price: number, quantity?: number): number => {
        return parseFloat((price / (quantity || 1)).toFixed(2));
    };
}
